import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights, responsiveBreakPoints, spacings } from '@styles/DesignVariables';

interface StyledButton {
	$buttonHoverBackground?: string;
	$buttonBackground?: string;
	$buttonTextColor?: string;
}

export const StyledButton = styled.button<StyledButton>`
	font-size: ${fontSizes.buttonText};
	line-height: ${lineHeights.buttonText};
	font-weight: ${fontWeights.bold};
	padding: 15px ${spacings.s24};
	border-radius: ${spacings.s20};
	border: none;
	min-width: 218px;
	cursor: pointer;
	display: flex;
	gap: 12px;
	text-align: center;
	justify-content: center;
	align-items: center;
	background: ${({ $buttonBackground }) => $buttonBackground};
	color: ${({ $buttonTextColor }) => $buttonTextColor};
	transition: all 0.4s;
	border: none;
	width: 100%;
	position: relative;

	&:hover {
		background-color: ${({ $buttonHoverBackground }) => $buttonHoverBackground};
	}

	@media ${responsiveBreakPoints.maxTablet} {
		display: flex;
		max-width: 100%;
		width: 100%;
	}
`;
